<template>
  <activities-grid :activities="myDrafts" :is-draft="true"></activities-grid>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ActivitiesGrid from "../components/Activities/ActivitiesGrid";

export default {
  name: "MyActivities",
  components: {
    ActivitiesGrid
  },
  computed: {
    ...mapGetters({
      myDrafts: "activities/getAllDrafts"
    })
  },
  created() {
    this.fetchDraftActivities();
  },
  methods: {
    ...mapActions({ fetchDraftActivities: "activities/fetchDraftActivities" })
  }
};
</script>
